// Func = limiting Scope for this file
var lastScrollTop = 0


if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
};
(function () {
	let itemsMenu = document.querySelectorAll(
		'.privary-navigation .privary-navigation__item',
	)
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			itemMenu.addEventListener('mouseover', () => {
				itemMenu.classList.add('hover')
				itemMenu.querySelector('.submenu').classList.add('show')
			})
			itemMenu.addEventListener('mouseout', () => {
				itemMenu.classList.remove('hover')
				itemMenu.querySelector('.submenu').classList.remove('show')
			})
		}
	})

	let itemsMenuMobile = document.querySelectorAll('.inner ul li');
	itemsMenuMobile.forEach((itemMenuMobile) => {
		if (itemMenuMobile.querySelector('.submenu')) {
			// Use click event for mobile devices
			itemMenuMobile.addEventListener('click', function (e) {
				// Prevent toggling when clicking inside submenu
				if (e.target.closest('.submenu')) return;
				e.stopPropagation();
				itemMenuMobile.classList.toggle('hover');
				itemMenuMobile.querySelector('.submenu').classList.toggle('show');
			});
		}
	});

	// Optional: Close other open submenus when opening a new one
	document.addEventListener('click', function (e) {
		itemsMenuMobile.forEach((itemMenuMobile) => {
			if (
				itemMenuMobile.classList.contains('hover') &&
				!itemMenuMobile.contains(e.target)
			) {
				itemMenuMobile.classList.remove('hover');
				const submenu = itemMenuMobile.querySelector('.submenu');
				if (submenu) submenu.classList.remove('show');
			}
		});
	});
	
	// Burger Menu Funcionality Open and Close Menu
	//open menu 
	document.querySelectorAll(".cta-menu-js").forEach( btn => {
		btn.addEventListener("click", (e)  => {
			console.log("click");
			e.preventDefault();
			document.querySelector("#burger-menu").classList.add("open")
			document.querySelector("body").classList.add("no-scroll")
		}, false)
	});

	//close menu
	if (document.querySelector(".burger-close-js")) {
		document.querySelector(".burger-close-js").addEventListener("click" , (e) => {
			e.preventDefault();
			document.querySelector("#burger-menu").classList.remove("open")
			document.querySelector("body").classList.remove("no-scroll")
		});
	}

	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	//cms form focus animation
	if (document.querySelectorAll('.form-module__field').length > 0) {
		document.querySelectorAll('.form-module__field').forEach(field => {
			if (field.querySelector('input')) {
				field.querySelector('input').addEventListener('focus', () => { field.classList.add('focused') })
			}
			if (field.querySelector('select')) {
				field.querySelector('select').addEventListener('focus', () => { field.classList.add('focused') })
			}
			if (field.querySelector('textarea')) {
				field.querySelector('textarea').addEventListener('focus', () => { field.classList.add('focused') })
			}
		});
	}
	if (document.querySelectorAll('.field').length > 0) {
		document.querySelectorAll('.field').forEach(field => {
			if (field.querySelector('input')) {
				field.querySelector('input').addEventListener('focus', () => { field.classList.add('focused') })
			}
			if (field.querySelector('select')) {
				field.querySelector('select').addEventListener('focus', () => { field.classList.add('focused') })
			}
			if (field.querySelector('textarea')) {
				field.querySelector('textarea').addEventListener('focus', () => { field.classList.add('focused') })
			}
		});
	}

	//js animation parallax imagen
	const images = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax),.parallax');
	new Ukiyo(images, {
		scale: 1.15,
		speed: 1.5,
		willChange: true
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(
		'.email-signup .input input',
	)
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	let logoHeaderImg = document.querySelector('.js-scroll-logo img')
	let logoHeader = `/assets/svg/logo-white.svg`
	let logoHeaderScroll = `/assets/svg/logo-blue.svg`

	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
				logoHeaderImg.setAttribute('src', logoHeaderScroll)
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
				logoHeaderImg.setAttribute('src', logoHeaderScroll)
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
			logoHeaderImg.setAttribute('src', logoHeader)
		}
	}
	if (document.getElementById('header').classList.contains('internal')) {
		logoHeaderImg.setAttribute('src', logoHeaderScroll)
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

document.querySelectorAll(".js-toggle-active").forEach(element => {
	element.addEventListener("click", (e) => {
		e.stopPropagation();
		element.classList.toggle("active");
	});
});

// Close active element when clicking outside
document.addEventListener("click", (e) => {
	if (!e.target.closest(".js-toggle-active")) {
		document.querySelectorAll(".js-toggle-active.active").forEach(el => {
			el.classList.remove("active");
		});
	}
});

/* Lightbox Gallerys */
const customLightbox = new LBX('.js-lbx-gallery', {
	customClass: 'lbx-gallery',
	fullScreen: true,
});